import Head from "next/head";

const CRITICAL_CSS = `
.mx-auto{margin-left:auto;margin-right:auto}
.max-w-layout{max-width:1440px}

.relative{position:relative}

@media (min-width:900px){
  /* <div className="md:flex"> */
  .md\\:flex{display:flex}
  /* LeftSideBar column <div className="md:w-[13%]"> */
  .md\\:w-\\[13\\%\\]{width:13%}
  /* SubMenu column <div className="md:w-[87%] relative"> */
  .md\\:w-\\[87\\%\\]{width:87%}
}
  
.sidebar {
  align-self: flex-start;
  position: sticky;
  top: 92px;
  overflow-y: scroll;
  height: calc(100vh - 92px);

  @media screen and (max-width: 800px) {
    display: none;
    height: unset;
  }
}

.submenu {
  display: inline-block;
  position: fixed;
  top: unset;
  overflow-y: auto;
  width: 160px;
  z-index: 100;
  border-radius: 0px;
  background-color: white;
  @media screen and (max-width: 800px) {
    display: none;
    height: unset;
  }
}
/* DesktopNavbar */
.searchInput {
  width: 100%;
}

.headers {
  top: 0;
  position: -webkit-sticky;
  position: sticky;
  z-index: 500;
}
`;

const LayoutCritical = () => (
  <Head>
    <style
      key="layout-critical-css"
      dangerouslySetInnerHTML={{ __html: CRITICAL_CSS }}
    />
  </Head>
);

export default LayoutCritical;
